module.exports = __webpack_public_path__ + "img/landingpage-bg1.4e411f13.png";